import { render, staticRenderFns } from "./SecuredApp.vue?vue&type=template&id=6980ada8&scoped=true&"
import script from "./SecuredApp.vue?vue&type=script&lang=js&"
export * from "./SecuredApp.vue?vue&type=script&lang=js&"
import style0 from "./SecuredApp.vue?vue&type=style&index=0&id=6980ada8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980ada8",
  null
  
)

export default component.exports